import { initSubRoutes } from '../../../../utils/router';

const RoutesAjoutAdresseSecondaire = initSubRoutes({
    route: '/ajouter-adresse-secondaire',
    subroutes: {},
    nom: 'Ajouter une adresse secondaire',
});

export default RoutesAjoutAdresseSecondaire;
